var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 70,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0415 10.8749V2.39575L22.5207 10.8749M3.24984 0.083252C1.53859 0.083252 0.166504 1.45534 0.166504 3.16659V27.8333C0.166504 28.651 0.491354 29.4353 1.06959 30.0135C1.64783 30.5917 2.43209 30.9166 3.24984 30.9166H21.7498C22.5676 30.9166 23.3518 30.5917 23.9301 30.0135C24.5083 29.4353 24.8332 28.651 24.8332 27.8333V9.33325L15.5832 0.083252H3.24984Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.2098b49d5067b958c210f3779ecb7ae5.svg";
export { ForwardRef as ReactComponent };